var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8557 0H3.14435C2.31064 0.000736816 1.51129 0.332252 0.921772 0.921772C0.332252 1.51129 0.000736816 2.31064 0 3.14435V12.8557C0.000736816 13.6894 0.332252 14.4887 0.921772 15.0782C1.51129 15.6677 2.31064 15.9993 3.14435 16H12.8557C13.6894 15.9993 14.4887 15.6677 15.0782 15.0782C15.6677 14.4887 15.9993 13.6894 16 12.8557V3.14435C15.9993 2.31064 15.6677 1.51129 15.0782 0.921772C14.4887 0.332252 13.6894 0.000736816 12.8557 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84121 13.4957C6.78962 13.4957 6.73802 13.4849 6.69072 13.4613C6.54238 13.3883 6.46713 13.223 6.51013 13.0641L7.57647 9.11398H4.69133C4.56019 9.11398 4.44195 9.04099 4.3839 8.92291C4.32585 8.80698 4.33875 8.66744 4.41615 8.56225L8.8836 2.6413C8.9825 2.51034 9.16094 2.46741 9.30928 2.53825C9.45762 2.61125 9.53286 2.77655 9.48987 2.93542L8.42353 6.88558H11.3087C11.4398 6.88558 11.5581 6.95857 11.6161 7.07664C11.6741 7.19257 11.6612 7.33212 11.5839 7.43731L7.1164 13.3583C7.04975 13.4463 6.94656 13.4957 6.84121 13.4957Z",
    fill: "url(#paint0_linear_2595_870)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2595_870",
    x1: 4.77518,
    y1: 2.80446,
    x2: 7.9916,
    y2: 13.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF70A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394DC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.77278da784bbb2996c83e3316222a1d9.svg";
export { ForwardRef as ReactComponent };